<div class="container-fluid">
    <app-pagetitle title="Add-Appointment" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
</div>
<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">

                <button type="button" class="btn btn-success" (click)="gotoprescriptionlist()">
                    <i class=" ri-menu-2-fill align-middle me-2"></i> Appointment-List
                </button>
                <form (ngSubmit)="typeSubmit()" [formGroup]="appt_form">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Phone Number<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <div>
                                    <input formControlName="phone_number" type="text" minlength="10" maxlength="10"
                                        class="form-control" (keypress)="numericOnly($event)"
                                        [ngClass]="{'is-invalid': typesubmit && type.phone_number.errors}" (input)="onPhoneNumberChange($event)"
                                        placeholder="Enter only numbers">
                                    <div *ngIf="typesubmit && type.phone_number.errors" class="invalid-feedback">
                                        <span *ngIf="type.phone_number.errors.required">This value is required.</span>
                                        <span *ngIf="type.phone_number.errors.pattern">This value should be a valid
                                            Phone Number.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Patient Type </label>
                                <input type="text" class="form-control" formControlName="patient_type"
                                     />
                                <!-- <div *ngIf="typesubmit && type.last_name.errors" class="invalid-feedback">
                                    <span *ngIf="type.last_name.errors.required">This value is required.</span>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Salutation </label>
                                <ng-select id="inputstate" id="default-select" formControlName="salutation">
                                    <ng-option value="" disabled Selected>Select the Option</ng-option>
                                    <ng-option value="Mr">Mr.</ng-option>
                                    <ng-option value="Mrs">Mrs.</ng-option>
                                    <ng-option value="Miss">Miss.</ng-option>
                                    <ng-option value="Master">Master.</ng-option>
                                    <ng-option value="Baby">Baby.</ng-option>
                                    <ng-option value="Ms">Ms.</ng-option>
                                    <ng-option value="Dr">Dr.</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Name<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="name"
                                    [ngClass]="{'is-invalid': typesubmit && type.name.errors}"
                                    placeholder="Type something" />
                                <div *ngIf="typesubmit && type.name.errors" class="invalid-feedback">
                                    <span *ngIf="type.name.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Surname <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="last_name"
                                    [ngClass]="{'is-invalid': typesubmit && type.last_name.errors}"
                                    placeholder="Type something" />
                                <div *ngIf="typesubmit && type.last_name.errors" class="invalid-feedback">
                                    <span *ngIf="type.last_name.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Age<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <div>
                                    <input formControlName="age" type="text" minlength="2" maxlength="2"
                                        class="form-control" [ngClass]="{'is-invalid': typesubmit && type.age.errors}"
                                        placeholder="Enter only numbers" (keypress)="numericOnly($event)">
                                    <div *ngIf="typesubmit && type.age.errors" class="invalid-feedback">
                                        <span *ngIf="type.age.errors.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Date of Birth <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="date" [max]="now" class="form-control" formControlName="dob"
                                    [ngClass]="{'is-invalid': typesubmit && type.dob.errors}"
                                    placeholder="Type something" />
                                <div *ngIf="typesubmit && type.dob.errors" class="invalid-feedback">
                                    <span *ngIf="type.dob.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Gender<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <div>
                                    <select formControlName="gender" class="form-control"
                                        [ngClass]="{'is-invalid': typesubmit && type.gender.errors}">
                                        <option value="" selected>Select</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    <div *ngIf="typesubmit && type.gender.errors" class="invalid-feedback">
                                        <span *ngIf="type.gender.errors.required">This value is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Occupation</label>
                                <input type="text" class="form-control" formControlName="occupation"
                                    [ngClass]="{'is-invalid': typesubmit && type.guardian.errors}"
                                    placeholder="Type something" />
                                <!-- <div *ngIf="typesubmit && type.guardian.errors" class="invalid-feedback">
                                    <span *ngIf="type.guardian.errors.required">This value is required.</span>
                                </div> -->
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Guardian (optional)</label>
                                <input type="text" class="form-control" formControlName="guardian"
                                    [ngClass]="{'is-invalid': typesubmit && type.guardian.errors}"
                                    placeholder="Type something" />
                                <!-- <div *ngIf="typesubmit && type.guardian.errors" class="invalid-feedback">
                                    <span *ngIf="type.guardian.errors.required">This value is required.</span>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Aadhar (optional)</label>
                                <input type="text " class="form-control" formControlName="aadhar" minlength="12"
                                    maxlength="12" [ngClass]="{'is-invalid': typesubmit && type.aadhar.errors}"
                                    placeholder="Type something" />
                                <!-- <div *ngIf="typesubmit && type.aadhar.errors" class="invalid-feedback">
                                    <span *ngIf="type.aadhar.errors.required">This value is required.</span>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Address</label>
                                <input type="text " class="form-control" formControlName="address" 
                                   [ngClass]="{'is-invalid': typesubmit && type.aadhar.errors}"
                                    placeholder="Type something" />
                                <!-- <div *ngIf="typesubmit && type.aadhar.errors" class="invalid-feedback">
                                    <span *ngIf="type.aadhar.errors.required">This value is required.</span>
                                </div> -->
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Alternative Number(optional)<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <div>
                                    <input formControlName="alt_number" type="text" minlength="10" maxlength="10"
                                        class="form-control" (keypress)="numericOnly($event)"
                                        placeholder="Enter only numbers">
                                    <!-- <div *ngIf="typesubmit && type.phone_number.errors" class="invalid-feedback">
                                        <span *ngIf="type.phone_number.errors.required">This value is required.</span>
                                        <span *ngIf="type.phone_number.errors.pattern">This value should be a valid
                                            Phone Number.</span>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                       
                        <!-- <div class="col-lg-4">
                            <div class="form-group">
                                <label>Patient Type <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <ng-select id="inputstate" id="default-select" formControlName="patient_type">
                                    <ng-option value="" Selected>Select </ng-option>
                                    <ng-option value="Old Patient">Old Patient</ng-option>
                                    <ng-option value="New Patient">New Patient</ng-option>
                                </ng-select>
                            </div>
                            <div *ngIf="typesubmit && type.infosource.errors" class="invalid-feedback">
                                <span *ngIf="type.infosource.errors.required">This value is required.</span>
                            </div>
                        </div> -->

                        <h3 class="card-title">
                            <br><b>Enter Appointment details :- </b><br>
                        </h3>

                        <!-- <div class="col-lg-12">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="cash"
                                    value="cash" formControlName="pymnt_mode">
                                <label class="form-check-label" for="inlineRadio1">Cash</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="cashless"
                                    value="cashless" formControlName="pymnt_mode">
                                <label class="form-check-label" for="inlineRadio2">Cashless</label>
                            </div>
                        </div> -->

                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Appointment Date<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="date" [min]="now" class="form-control" formControlName="appointment_date"
                                    [ngClass]="{'is-invalid': typesubmit && type.appointment_date.errors}"
                                    placeholder="Type something" />
                                <div *ngIf="typesubmit && type.appointment_date.errors" class="invalid-feedback">
                                    <span *ngIf="type.appointment_date.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Time Slot <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <!-- <input type="time" step="00:15" class="form-control" formControlName="time_slot"
                                    [ngClass]="{'is-invalid': typesubmit && type.time_slot.errors}"
                                    placeholder="Type something" /> -->

                                <ng-select formControlName="time_slot"
                                    [ngClass]="{'is-invalid': typesubmit && type.time_slot.errors}">
                                    <ng-option value="" selected>Select the Time</ng-option>
                                    <ng-option value="08:00 AM">08:00 AM</ng-option>
                                    <ng-option value="08:15 AM">08:15 AM</ng-option>
                                    <ng-option value="08:30 AM">08:30 AM</ng-option>
                                    <ng-option value="08:45 AM">08:45 AM</ng-option>
                                    <ng-option value="09:00 AM">09:00 AM</ng-option>
                                    <ng-option value="09:15 AM">09:15 AM</ng-option>
                                    <ng-option value="09:30 AM">09:30 AM</ng-option>
                                    <ng-option value="09:45 AM">09:45 AM</ng-option>
                                    <ng-option value="10:00 AM">10:00 AM</ng-option>
                                    <ng-option value="10:15 AM">10:15 AM</ng-option>
                                    <ng-option value="10:30 AM">10:30 AM</ng-option>
                                    <ng-option value="10:45 AM">10:45 AM</ng-option>
                                    <ng-option value="11:00 AM">11:00 AM</ng-option>
                                    <ng-option value="11:15 AM">11:15 AM</ng-option>
                                    <ng-option value="11:30 AM">11:30 AM</ng-option>
                                    <ng-option value="11:45 AM">11:45 AM</ng-option>
                                    <ng-option value="12:00 PM">12:00 PM</ng-option>
                                    <ng-option value="12:15 PM">12:15 PM</ng-option>
                                    <ng-option value="12:30 PM">12:30 PM</ng-option>
                                    <ng-option value="12:45 PM">12:45 PM</ng-option>
                                    <ng-option value="01:00 PM">01:00 PM</ng-option>
                                    <ng-option value="01:15 PM">01:15 PM</ng-option>
                                    <ng-option value="01:30 PM">01:30 PM</ng-option>
                                    <ng-option value="01:45 PM">01:45 PM</ng-option>
                                    <ng-option value="02:00 PM">02:00 PM</ng-option>
                                    <ng-option value="02:15 PM">02:15 PM</ng-option>
                                    <ng-option value="02:30 PM">02:30 PM</ng-option>
                                    <ng-option value="02:45 PM">02:45 PM</ng-option>
                                    <ng-option value="03:00 PM">03:00 PM</ng-option>
                                    <ng-option value="03:15 PM">03:15 PM</ng-option>
                                    <ng-option value="03:30 PM">03:30 PM</ng-option>
                                    <ng-option value="03:45 PM">03:45 PM</ng-option>
                                    <ng-option value="04:00 PM">04:00 PM</ng-option>
                                    <ng-option value="04:15 PM">04:15 PM</ng-option>
                                    <ng-option value="04:30 PM">04:30 PM</ng-option>
                                    <ng-option value="04:45 PM">04:45 PM</ng-option>
                                    <ng-option value="05:00 PM">05:00 PM</ng-option>
                                    <ng-option value="05:15 PM">05:15 PM</ng-option>
                                    <ng-option value="05:30 PM">05:30 PM</ng-option>
                                    <ng-option value="05:45 PM">05:45 PM</ng-option>
                                    <ng-option value="06:00 PM">06:00 PM</ng-option>
                                    <ng-option value="06:15 PM">06:15 PM</ng-option>
                                    <ng-option value="06:30 PM">06:30 PM</ng-option>
                                    <ng-option value="06:45 PM">06:45 PM</ng-option>
                                    <ng-option value="07:00 PM">07:00 PM</ng-option>
                                    <ng-option value="07:15 PM">07:15 PM</ng-option>
                                    <ng-option value="07:30 PM">07:30 PM</ng-option>
                                    <ng-option value="07:45 PM">07:45 PM</ng-option>
                                    <ng-option value="08:00 PM">08:00 PM</ng-option>
                                    <!-- <ng-option value="Female">Female</ng-option>
                                    <ng-option value="Other">Other</ng-option> -->
                                </ng-select>
                                <div *ngIf="typesubmit && type.time_slot.errors" class="invalid-feedback">
                                    <span *ngIf="type.time_slot.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>No.of days to Expiry<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="days_to_expiry"
                                    [ngClass]="{'is-invalid': typesubmit && type.days_to_expiry.errors}"
                                    placeholder="Type something" (keypress)="numericOnly($event)" />
                                <div *ngIf="typesubmit && type.days_to_expiry.errors" class="invalid-feedback">
                                    <span *ngIf="type.days_to_expiry.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Consultant Fees <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="amount" value="0"
                                    [ngClass]="{'is-invalid': typesubmit && type.amount.errors}"
                                    (keypress)="numericOnly($event)" placeholder="Type something"  />
                                <div *ngIf="typesubmit && type.amount.errors" class="invalid-feedback">
                                    <span *ngIf="type.amount.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Doctor Name <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <ng-select formControlName="doctor_name" (change)="getdep($event)"
                                    [ngClass]="{'is-invalid': typesubmit && type.doctor_name.errors}">
                                    <ng-option value="" disabled Selected>Select The Doctor</ng-option>
                                    <ng-option *ngFor="let i of doctordata"
                                        value="{{i.doctor_name}}">{{i.doctor_name}}</ng-option>
                                </ng-select>
                                <div *ngIf="typesubmit && type.doctor_name.errors" class="invalid-feedback">
                                    <span *ngIf="type.doctor_name.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Department Name <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="department_name"
                                    [ngClass]="{'is-invalid': typesubmit && type.department_name.errors}"
                                    placeholder="Type something" />
                                <div *ngIf="typesubmit && type.department_name.errors" class="invalid-feedback">
                                    <span *ngIf="type.department_name.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Information Source </label>
                                <ng-select id="inputstate" id="default-select" formControlName="infosource">
                                    <ng-option value="" disabled Selected>Select the Option</ng-option>
                                    <ng-option>Old-patient</ng-option>
                                    <ng-option>Website</ng-option>
                                    <ng-option>Facebook</ng-option>
                                    <ng-option>Television Ad</ng-option>
                                    <ng-option>Mouth Publicity</ng-option>
                                    <ng-option>Referral</ng-option>
                                    <ng-option>Newspaper</ng-option>
                                    <ng-option>Other</ng-option>
                                </ng-select>
                            </div>
                            <div *ngIf="typesubmit && type.infosource.errors" class="invalid-feedback">
                                <span *ngIf="type.infosource.errors.required">This value is required.</span>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Payment type <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <ng-select id="inputstate" id="default-select" formControlName="pymnt_type" (change)="selectfield($event)"   [class.is-invalid]="typesubmit && type.pymnt_type.errors">
                                    <ng-option value="" selected>Select Payment Method</ng-option>
                                    <ng-option value="cash">Cash</ng-option>
                                    <ng-option value="upi">UPI</ng-option>
                                    <!-- <ng-option value="card">Credit/Debit Cards</ng-option>
                                    <ng-option value="netBanking">Net Banking</ng-option> -->
                                    <ng-option value="other">Other</ng-option>
                                </ng-select>
                                <div *ngIf="typesubmit && type.pymnt_type.errors" class="invalid-feedback">
                                    <span *ngIf="type.pymnt_type.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>

                        <!-- UPI Field (Hidden initially) -->
                        <div class="col-lg-4" *ngIf="upi">
                            <div class="form-group">
                                <label>Enter Transaction ID <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="upiId"
                                    [ngClass]="{'is-invalid': typesubmit && type.amount.errors}"
                                     placeholder="Enter Transaction ID" />
                               
                            </div>
                        </div>

                        <!-- Net Banking Field (Hidden initially) -->
                        <!-- <div class="col-lg-4" *ngIf="netBanking">
                            <div class="form-group">
                                <label>Enter Transaction ID <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="netBanking"
                                    [ngClass]="{'is-invalid': typesubmit && type.amount.errors}"
                                    (keypress)="numericOnly($event)" placeholder="Enter Account Number" />
                               
                            </div>
                        </div> -->

                        <!-- Card Payment Field (Hidden initially) -->

                        <!-- <div class="col-lg-4" *ngIf="card">
                            <div class="form-group">
                                <label>Enter Card Number:<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="number" class="form-control" formControlName="cardNumber"
                                    [ngClass]="{'is-invalid': typesubmit && type.amount.errors}"
                                    (keypress)="numericOnly($event)" placeholder="XXXX XXXX XXXX XXXX" />
                                
                            </div>
                        </div> -->

                        <!-- <div class="col-lg-4" *ngIf="card">
                            <div class="form-group">
                                <label>Expiry Date:<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="expiryDate"
                                    [ngClass]="{'is-invalid': typesubmit && type.amount.errors}" placeholder="MM/YY" />
                                
                            </div>
                        </div> -->

                        <!-- <div class="col-lg-4" *ngIf="card">
                            <div class="form-group">
                                <label>CVV:<span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="number" class="form-control" formControlName="cvv"
                                    [ngClass]="{'is-invalid': typesubmit && type.amount.errors}"
                                    (keypress)="numericOnly($event)" placeholder="Enter 3 Digit Code" />
                              
                            </div>
                        </div> -->

                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Discount % </label>
                                <ng-select id="inputstate" id="default-select" formControlName="discount">
                                    <ng-option value="" disabled Selected>Select the Option</ng-option>
                                    <ng-option value="5">5%</ng-option>
                                    <ng-option value="10">10%</ng-option>
                                    <ng-option value="15">15%</ng-option>
                                    <ng-option value="20">20%</ng-option>
                                    <ng-option value="25">25%</ng-option>
                                    <ng-option value="30">30%</ng-option>
                                    <ng-option value="35">35%</ng-option>
                                    <ng-option value="40">40%</ng-option>
                                    <ng-option value="45">45%</ng-option>
                                    <ng-option value="50">50%</ng-option>
                                    <ng-option value="other">Other</ng-option>
                                </ng-select>
                            </div>
                            <!-- <div *ngIf="typesubmit && type.infosource.errors" class="invalid-feedback">
                                <span *ngIf="type.infosource.errors.required">This value is required.</span>
                            </div> -->
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Patient Brief <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <textarea type="text" class="form-control" formControlName="problem"
                                    [ngClass]="{'is-invalid': typesubmit && type.problem.errors}"
                                    placeholder="Type something" rows="3"></textarea>
                                <div *ngIf="typesubmit && type.problem.errors" class="invalid-feedback">
                                    <span *ngIf="type.problem.errors.required">This value is required.</span>
                                </div>
                            </div>
                        </div>


                    </div>
                </form>
                <div class="form-group mb-0" style="text-align: right;">
                    <br>
                    <button type="submit" class="btn btn-primary me-1" (click)="typeSubmit()"> Submit </button>
                    <button type="reset" class="btn btn-secondary" (click)="reset()"> Reset </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title"> Today Appointments Data </h4>
                <div class="table-responsive">
                    <table class="table table-bordered table-striped mb-0 table-striped">
                        <thead class="table-dark">
                            <tr>
                                <th>S.no</th>
                                <th>UHID</th>
                                <th>Booking date / Time</th>
                                <th>Name</th>
                                <th>Age</th>
                                <th>Gender</th>
                                <th>Number</th>
                                <th>Fee</th>
                                <th>Expiry Date</th>
                                <th>Discount %</th>
                                <th>Discount Amount</th>
                                <th>Total Amount</th>
                                <th>Prints </th>
                                <th>Action </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let i of data;let y =index">
                                <td scope="row">{{y+1}}</td>
                                <td>{{i.patient_id}}</td>
                                <td>{{i.appointment_date | date:'dd-MM-yyyy'}} / {{i.time_slot}} </td>
                                <td>{{i.salutation}} {{i.name}} {{i.last_name}}</td>
                                <td>{{i.age}}</td>
                                <td>{{i.gender}}</td>
                                <td>{{i.number}}</td>
                                <td>{{i.amount}}</td>
                                <td style="min-width: 110px !important;">{{i.expiry_date}}</td>
                                <td>{{i.discount}}</td>
                                <td>{{ (i.discount / 100) * i.amount | number: '1.2-2' }}</td>
                                <td>{{ i.amount - (i.discount / 100) * i.amount | number: '1.2-2' }}</td>

                                <td align="center">
                                    <a>
                                        <i style="font-size: 20px;border-radius:5px;background-color: rgb(33, 130, 44);color: white;padding: 4%;"
                                            class="fa fa-print" (click)="printData(i)"></i></a>
                                </td>
                                <td>
                                    <div style="display: flex;">


                                        <i style="font-size: 20px;border-radius:5px;background-color: rgb(31, 115, 31);color: white;padding: 2%;"
                                            class="ri-edit-fill" title="Edit"
                                            (click)="centerModal(centerDataModal,i)"></i>&nbsp;&nbsp;
                                        <!-- <i style="font-size: 20px;border-radius:5px;background-color: rgb(83, 12, 12);color: white;padding: 2%;"
                                            class="ri-delete-bin-2-line" title="Delete" (click)="Delete(i)"></i> -->
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #centerDataModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">Edit Patients Details </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <form (ngSubmit)="edit()" [formGroup]="editForm">
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Appointment Date<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="date" [min]="now" class="form-control" formControlName="appointment_date"
                            placeholder="Type something" />
                        <!-- <div *ngIf="typesubmit && type.appointment_date.errors" class="invalid-feedback">
                            <span *ngIf="type.appointment_date.errors.required">This value is required.</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Time Slot <span style="color:red">&nbsp;&nbsp;*</span></label>
                       

                        <ng-select formControlName="time_slot">
                            <ng-option value="" selected>Select the Time</ng-option>
                            <ng-option value="08:00 AM">08:00 AM</ng-option>
                            <ng-option value="08:15 AM">08:15 AM</ng-option>
                            <ng-option value="08:30 AM">08:30 AM</ng-option>
                            <ng-option value="08:45 AM">08:45 AM</ng-option>
                            <ng-option value="09:00 AM">09:00 AM</ng-option>
                            <ng-option value="09:15 AM">09:15 AM</ng-option>
                            <ng-option value="09:30 AM">09:30 AM</ng-option>
                            <ng-option value="09:45 AM">09:45 AM</ng-option>
                            <ng-option value="10:00 AM">10:00 AM</ng-option>
                            <ng-option value="10:15 AM">10:15 AM</ng-option>
                            <ng-option value="10:30 AM">10:30 AM</ng-option>
                            <ng-option value="10:45 AM">10:45 AM</ng-option>
                            <ng-option value="11:00 AM">11:00 AM</ng-option>
                            <ng-option value="11:15 AM">11:15 AM</ng-option>
                            <ng-option value="11:30 AM">11:30 AM</ng-option>
                            <ng-option value="11:45 AM">11:45 AM</ng-option>
                            <ng-option value="12:00 PM">12:00 PM</ng-option>
                            <ng-option value="12:15 PM">12:15 PM</ng-option>
                            <ng-option value="12:30 PM">12:30 PM</ng-option>
                            <ng-option value="12:45 PM">12:45 PM</ng-option>
                            <ng-option value="01:00 PM">01:00 PM</ng-option>
                            <ng-option value="01:15 PM">01:15 PM</ng-option>
                            <ng-option value="01:30 PM">01:30 PM</ng-option>
                            <ng-option value="01:45 PM">01:45 PM</ng-option>
                            <ng-option value="02:00 PM">02:00 PM</ng-option>
                            <ng-option value="02:15 PM">02:15 PM</ng-option>
                            <ng-option value="02:30 PM">02:30 PM</ng-option>
                            <ng-option value="02:45 PM">02:45 PM</ng-option>
                            <ng-option value="03:00 PM">03:00 PM</ng-option>
                            <ng-option value="03:15 PM">03:15 PM</ng-option>
                            <ng-option value="03:30 PM">03:30 PM</ng-option>
                            <ng-option value="03:45 PM">03:45 PM</ng-option>
                            <ng-option value="04:00 PM">04:00 PM</ng-option>
                            <ng-option value="04:15 PM">04:15 PM</ng-option>
                            <ng-option value="04:30 PM">04:30 PM</ng-option>
                            <ng-option value="04:45 PM">04:45 PM</ng-option>
                            <ng-option value="05:00 PM">05:00 PM</ng-option>
                            <ng-option value="05:15 PM">05:15 PM</ng-option>
                            <ng-option value="05:30 PM">05:30 PM</ng-option>
                            <ng-option value="05:45 PM">05:45 PM</ng-option>
                            <ng-option value="06:00 PM">06:00 PM</ng-option>
                            <ng-option value="06:15 PM">06:15 PM</ng-option>
                            <ng-option value="06:30 PM">06:30 PM</ng-option>
                            <ng-option value="06:45 PM">06:45 PM</ng-option>
                            <ng-option value="07:00 PM">07:00 PM</ng-option>
                            <ng-option value="07:15 PM">07:15 PM</ng-option>
                            <ng-option value="07:30 PM">07:30 PM</ng-option>
                            <ng-option value="07:45 PM">07:45 PM</ng-option>
                            <ng-option value="08:00 PM">08:00 PM</ng-option>
                            
                        </ng-select>
                        <!-- <div *ngIf="typesubmit && type.time_slot.errors" class="invalid-feedback">
                            <span *ngIf="type.time_slot.errors.required">This value is required.</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Salutation </label>
                        <ng-select id="inputstate" id="default-select" formControlName="salutation">
                            <ng-option value="" disabled Selected>Select the Option</ng-option>
                            <ng-option value="Mr">Mr.</ng-option>
                            <ng-option value="Mrs">Mrs.</ng-option>
                            <ng-option value="Miss">Miss.</ng-option>
                            <ng-option value="Master">Master.</ng-option>
                            <ng-option value="Baby">Baby.</ng-option>
                            <ng-option value="Ms">Ms.</ng-option>
                            <ng-option value="Dr">Dr.</ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Name<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="name"
                           
                            placeholder="Type something" />
                        <!-- <div *ngIf="typesubmit && type.name.errors" class="invalid-feedback">
                            <span *ngIf="type.name.errors.required">This value is required.</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Surname <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="last_name"
                           
                            placeholder="Type something" />
                        <!-- <div *ngIf="typesubmit && type.last_name.errors" class="invalid-feedback">
                            <span *ngIf="type.last_name.errors.required">This value is required.</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Age<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <div>
                            <input formControlName="age" type="text" minlength="2" maxlength="2"
                                class="form-control" 
                                placeholder="Enter only numbers" (keypress)="numericOnly($event)">
                            <!-- <div *ngIf="typesubmit && type.age.errors" class="invalid-feedback">
                                <span *ngIf="type.age.errors.required">This value is required.</span>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Gender<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <div>
                            <select formControlName="gender" class="form-control"
                                >
                                <option value="" selected>Select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>
                            <!-- <div *ngIf="typesubmit && type.gender.errors" class="invalid-feedback">
                                <span *ngIf="type.gender.errors.required">This value is required.</span>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Phone Number<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <div>
                            <input formControlName="phone_number" type="text" minlength="10" maxlength="10"
                                class="form-control" (keypress)="numericOnly($event)"
                                placeholder="Enter only numbers">
                            <!-- <div *ngIf="typesubmit && type.phone_number.errors" class="invalid-feedback">
                                <span *ngIf="type.phone_number.errors.required">This value is required.</span>
                                <span *ngIf="type.phone_number.errors.pattern">This value should be a valid
                                    Phone Number.</span>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>No.of days to Expiry<span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="days_to_expiry"
                            placeholder="Type something" (keypress)="numericOnly($event)" />
                        <!-- <div *ngIf="typesubmit && type.days_to_expiry.errors" class="invalid-feedback">
                            <span *ngIf="type.days_to_expiry.errors.required">This value is required.</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Consultant Fees <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="amount" value="0"
                            (keypress)="numericOnly($event)" placeholder="Type something"  />
                        <!-- <div *ngIf="typesubmit && type.amount.errors" class="invalid-feedback">
                            <span *ngIf="type.amount.errors.required">This value is required.</span>
                        </div> -->
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Discount % </label>
                        <ng-select id="inputstate" id="default-select" formControlName="discount">
                            <ng-option value="" disabled Selected>Select the Option</ng-option>
                            <ng-option value="5">5%</ng-option>
                            <ng-option value="10">10%</ng-option>
                            <ng-option value="15">15%</ng-option>
                            <ng-option value="20">20%</ng-option>
                            <ng-option value="25">25%</ng-option>
                            <ng-option value="30">30%</ng-option>
                            <ng-option value="35">35%</ng-option>
                            <ng-option value="40">40%</ng-option>
                            <ng-option value="45">45%</ng-option>
                            <ng-option value="50">50%</ng-option>
                        </ng-select>
                    </div>
                    <!-- <div *ngIf="typesubmit && type.infosource.errors" class="invalid-feedback">
                        <span *ngIf="type.infosource.errors.required">This value is required.</span>
                    </div> -->
                </div>
               
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary me-1"> Save changes </button>
                    <button type="reset" class="btn btn-secondary"> Reset</button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<div class="my-overlay" *ngIf="loadingpart">
    <div class="cusloader"></div>
    <h5 style="color: white;">Please Wait...</h5>
</div>